import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToastStore } from '@pkg/components/Toast/useToastStore';

import { callAddItemToLiquidId } from '@app/client/resources/nbe/liquid-id-request-handler';

import { LID_CACHE } from './useGetLiquidIdItems';

export const useLiquidIdAddItem = () => {
    const queryClient = useQueryClient();
    const { addToast } = useToastStore();

    return useMutation({
        mutationFn: (item: string) => callAddItemToLiquidId({ value: { item } }),
        onMutate: () => {
            addToast({
                isLoader: true,
                message: `Workin' on it...`,
            });
        },
        onSuccess: () => {
            void queryClient.invalidateQueries({
                predicate: ({ queryKey }) => queryKey?.[0] === LID_CACHE,
            });

            addToast({
                emoji: '🚀',
                message: `NFT added to Liquid ID!`,
            });
        },
    });
};
